import type { ReportColumn } from '../models/column.types'

export const REPORT_MEDIA_COLUMN_FIELD = 'media'

function isMedia(column: ReportColumn): boolean {
  return column.isImage === true || column.sub_type === 'image'
}

/**
 * v3 `OrphexTable.vue:390-398` / `OrphexReportTable.vue:1740-1749`: a table showing more than one
 * media column collapses them into a single leading `media` column, because the creative carriers
 * (`preview_ss_url`, `image_url`, `thumbnail_url`) are alternate URLs for the same creative rather
 * than separate facts. The customize panel keeps offering them individually — only the rendered
 * table folds.
 */
export function collapseReportMediaColumns(
  columns: readonly ReportColumn[],
  header: string,
): ReportColumn[] {
  if (columns.some((column) => column.field === REPORT_MEDIA_COLUMN_FIELD)) return [...columns]
  const visibleMedia = columns.filter((column) => isMedia(column) && column.invisible !== true)
  if (visibleMedia.length < 2) return [...columns]

  const first = visibleMedia[0]!
  return [
    {
      ...first,
      field: REPORT_MEDIA_COLUMN_FIELD,
      header,
      isImage: true,
      numeric: false,
    },
    ...columns.filter((column) => !isMedia(column)),
  ]
}
